"use client";

import type React from "react"
import AuthProvider from "@/components/auth-provider"
import { AuthGuard } from "@/components/auth-guard"
import { SessionGuardGate } from "@/components/session-guard-gate"
import { CompanyProvider } from "@/contexts/CompanyContext"
import { usePathname } from "next/navigation"

interface ClientLayoutProps {
  children: React.ReactNode
}

export default function ClientLayout({ children }: ClientLayoutProps) {
  const pathname = usePathname();
  const isLoginPage = pathname.includes('/login');

  return (
    <AuthProvider>
      <CompanyProvider>
        {isLoginPage ? children : <AuthGuard><SessionGuardGate>{children}</SessionGuardGate></AuthGuard>}
      </CompanyProvider>
    </AuthProvider>
  )
}
